import { Flex, Title } from "@mantine/core";
import PushNotificationEvents from "../enums/PushNotificationEvents";
import { PushNotificationRequest } from "../models/PushNotificationRequest";

interface PushNotificationConfirmationProps {
  totalUsers: number;
  notification: PushNotificationRequest;
}

export const PushNotificationConfirmation = ({
  totalUsers,
  notification
}: PushNotificationConfirmationProps) => {
  return (
    <Flex direction="column" justify="center" align="center" gap="sm">
      <Title order={3}>
        Are you sure you want to send push notifications to all (
        {totalUsers}) users listed below?
      </Title>
      <Title order={3}>THIS ACTION CANNOT BE UNDONE</Title>

      <Title order={4}>Title: {notification.title}</Title>
      <Title order={4}>Body: {notification.body}</Title>
      {notification.notificationEvent ===
      PushNotificationEvents.WEB_LINK ? (
        <Title order={4}>URL: {notification.webLink}</Title>
      ) : null}
    </Flex>
  );
};
